import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { VendorService, Vendor } from '../../core/services/vendor.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrl: './vendors.component.scss'
})
export class VendorsComponent implements OnInit {

  vendors: Vendor[] = [];
  loading = false;
  error = '';
  successMessage = '';

  vendorForm: UntypedFormGroup;
  modalRef: NgbModalRef;
  editingVendor: Vendor | null = null;
  isEditMode = false;

  breadCrumbItems: Array<{}>;

  constructor(
    private vendorService: VendorService,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private toastService: ToastService
  ) {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Vendors', active: true }];
  }

  ngOnInit(): void {
    this.initForm();
    this.loadVendors();
  }

  initForm() {
    this.vendorForm = this.fb.group({
      name: ['', Validators.required],
      type: ['', Validators.required],
      status: ['Active', Validators.required],
      apiEndpoint: ['', Validators.required],
      apiKey: ['', Validators.required],
      successRate: [99.9, [Validators.required, Validators.min(0), Validators.max(100)]],
      avgResponseTime: [1.5, [Validators.required, Validators.min(0)]]
    });
  }

  loadVendors() {
    this.loading = true;
    this.error = '';
    this.vendorService.getVendors().subscribe(
      (data: Vendor[]) => {
        this.vendors = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  openCreateModal(content: any) {
    this.isEditMode = false;
    this.editingVendor = null;
    this.vendorForm.reset({ status: 'Active', successRate: 99.9, avgResponseTime: 1.5 });
    this.error = '';
    this.successMessage = '';
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  openEditModal(vendor: Vendor, content: any) {
    this.isEditMode = true;
    this.editingVendor = vendor;
    this.vendorForm.patchValue({
      name: vendor.name,
      type: vendor.type,
      status: vendor.status,
      apiEndpoint: vendor.apiEndpoint,
      apiKey: vendor.apiKey,
      successRate: vendor.successRate,
      avgResponseTime: vendor.avgResponseTime
    });
    this.error = '';
    this.successMessage = '';
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  saveVendor() {
    if (!this.vendorForm.valid) {
      const message = 'Please fill all required fields correctly.';
      this.toastService.showToaster("Form Validation", message, "info");
      return;
    }

    const formValue = this.vendorForm.value;
    const payload: Partial<Vendor> = {
      name: formValue.name,
      type: formValue.type,
      status: formValue.status,
      apiEndpoint: formValue.apiEndpoint,
      apiKey: formValue.apiKey,
      successRate: formValue.successRate,
      avgResponseTime: formValue.avgResponseTime
    };

    if (this.isEditMode && this.editingVendor) {
      this.vendorService.updateVendor(this.editingVendor._id, payload).subscribe(
        (updated: Vendor) => {
          const idx = this.vendors.findIndex(v => v._id === updated._id);
          if (idx > -1) {
            this.vendors[idx] = updated;
          }
          this.toastService.showToaster("Vender Updated", 'Vendor updated successfully!', "success");
          setTimeout(() => {
            this.modalRef.close();
          }, 1000);
        }, () => { }
      );
    } else {
      this.vendorService.createVendor(payload).subscribe(
        (newVendor: Vendor) => {
          this.vendors.push(newVendor);
          this.toastService.showToaster("Vender Created", 'Vendor created successfully!', "success");
          setTimeout(() => {
            this.modalRef.close();
          }, 1000);
        },
        () => { }
      );
    }
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }

  checkVendorHealth(vendor: Vendor) {
    this.vendorService.checkVendorHealth(vendor._id).subscribe(
      (response: any) => {
        const message = `Vendor "${vendor.name}" health check passed!`;
        this.toastService.showToaster("Success", message, "success");
        setTimeout(() => {
          this.successMessage = '';
        }, 3000);
      },
      () => { }
    );
  }
}
